import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { StaffsHelpbuttonService } from 'src/app/services/helpbutton-services/staffs-helpbutton-service/staffs-helpbutton.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-helpbutton-staffs-breadcrumb-card',
  templateUrl: './helpbutton-staffs-breadcrumb-card.component.html',
  styleUrls: ['./helpbutton-staffs-breadcrumb-card.component.scss']
})
export class HelpbuttonStaffsBreadcrumbCardComponent implements OnInit {

  @Input() staffs;
  filterOpened: boolean;
  viewDisposition;

  constructor(private router: Router,
    private userStorageService: UserStorageService,
              private staffsHelpbuttonService: StaffsHelpbuttonService,
              private activatedRoute: ActivatedRoute) { 
                this.viewDisposition = 'grid';
              }

  ngOnInit() {
    if (this.userStorageService.getFilterStaffs()) {
      this.toggleBreadcrumbFilter();
    }
  }

  public toggleViewDisposition(viewDis) {
    this.viewDisposition = viewDis;
    this.staffsHelpbuttonService.toggleStaffsDisposition(viewDis);
  }

  public createStaff() {
    this.router.navigate(['../../staff'], {relativeTo: this.activatedRoute });
  }

  public search(event) {
    this.staffsHelpbuttonService.searchStaffs(event.target.value);
  }

  public toggleBreadcrumbFilter() {
    this.filterOpened = !this.filterOpened;
  }

}
